export default {
  title: 'De ce să regenerezi această imagine?',
  description: 'Ajută-ne să îmbunătățim AI-ul spunându-ne ce nu a fost corect.',
  reasons: {
    wrong_style: 'Stil greșit',
    wrong_colors: 'Culori greșite',
    wrong_food_item: 'Preparat greșit',
    low_quality: 'Calitate scăzută',
    doesnt_match_brand: 'Nu se potrivește cu brandul meu',
    text_issues: 'Textul sau etichetele sunt greșite',
    other: 'Altul',
  },
  details_label: 'Altceva? (opțional)',
  details_placeholder: 'Adaugă mai multe detalii pentru a ne ajuta să înțelegem…',
  cancel: 'Anulează',
  confirm: 'Regenerează',
};
